import * as React from "react";
const SvgCarretDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.0001 15.5996L5.9751 9.59961L18.0251 9.59961L12.0001 15.5996Z", fill: "#757575" }));
export default SvgCarretDown;
